module.exports = __webpack_public_path__ + "img/49.e8e8bcd7.png";